<template>
    <v-sheet>
        <v-card outlined class="mb-20 mb-md-40 mb-lg-60">
            <v-img :src="program.image?.src" :aspect-ratio="772 / 400" class="grey-f7">
                <template #placeholder>
                    <v-overlay absolute light color="white">
                        <image-overlay>{{ program.host.name }}</image-overlay>
                    </v-overlay>
                </template>
            </v-img>
        </v-card>

        <div class="mb-20 mb-md-40 mb-lg-60">
            <h5 class="page-text--lg mb-8 mb-lg-16">
                <span> 기간안내 </span>
            </h5>
            <body-date v-bind="{ program }" />
        </div>

        <div class="mb-20 mb-md-40 mb-lg-60">
            <h5 class="page-text--lg mb-8 mb-lg-16">
                <span> 상세정보 </span>
            </h5>
            <v-divider class="primary border-2 mb-12 mb-lg-24" />
            <div v-html="program.content" />
        </div>

        <div class="mb-20 mb-md-40 mb-lg-60">
            <h5 class="page-text--lg mb-8 mb-lg-16">
                <v-row no-gutters align="center">
                    <v-col cols="auto">
                        <span> 문의하기 </span>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                        <expo-inquiry-form v-bind="{ program }" @input="onInputInquiryForm">
                            <template #activator="{ attrs, on }">
                                <v-btn small text height="27" color="primary" class="ma-n4 pa-4" v-bind="{ ...attrs, disabled }" v-on="on">
                                    <span> 호스트에게 문의하기 </span>
                                    <v-icon size="16" class="ml-8">mdi-chevron-right</v-icon>
                                </v-btn>
                            </template>
                        </expo-inquiry-form>
                    </v-col>
                </v-row>
            </h5>
            <expo-inquiry-list v-bind="{ program }" ref="inquiry-list" />
        </div>

        <div>
            <h5 class="page-text--lg mb-8 mb-lg-16">
                <span> 연락하기 </span>
            </h5>
            <body-info v-bind="{ program }" />
        </div>
    </v-sheet>
</template>

<script>
import { initExpoProgram } from "@/assets/variables/inits";

import ImageOverlay from "@/components/dumb/image-overlay.vue";

import ExpoInquiryForm from "@/components/client/expo/inquiries/expo-inquiry-form.vue";
import ExpoInquiryList from "@/components/client/expo/inquiries/expo-inquiry-list.vue";

import BodyDate from "./body/body-date.vue";
import BodyInfo from "./body/body-info.vue";

export default {
    components: {
        ImageOverlay,

        ExpoInquiryForm,
        ExpoInquiryList,

        BodyDate,
        BodyInfo,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
        isPreview: { type: Boolean, default: false },
    },
    computed: {
        disabled() {
            return this.isPreview || !this.program.isGranted;
        },
    },
    methods: {
        onInputInquiryForm(inquiry) {
            console.log(this.$refs["inquiry-list"]);
            this.$refs["inquiry-list"]?.updateItem?.(inquiry);
        },
    },
};
</script>

<style>
</style>